import { useQuery } from "@tanstack/react-query";
import vehicleChargingConfigService from "src/services/vehicleChargingConfigService";

/**
 * Is the Vehicle Charging section of the V2 dashboard on for this team?
 *
 * Follows the company flag set in Company → Settings by a super admin, for the team
 * the dashboard is showing — ON if the team OR its parent company has it on, so
 * enabling it for a company covers all its teams. There is intentionally NO super-
 * admin override: the section only shows where it is turned on. Resilient: off until
 * known and on any failure, so it never blocks the dashboard.
 */
export const useVehicleChargingEnabled = (teamId) => {
  const { data } = useQuery(
    ["vehicleChargingConfig", teamId],
    () => vehicleChargingConfigService.getTeamVehicleChargingConfig(teamId),
    {
      enabled: Boolean(teamId),
      staleTime: 5 * 60 * 1000,
      placeholderData: { vehicleChargingEnabled: false },
    }
  );
  return data?.vehicleChargingEnabled === true;
};

export default useVehicleChargingEnabled;
